import { AlertTitle, ColoredAlert } from '@bpinternal/ui-kit-next'
import { InfoIcon } from 'lucide-react'
import { useSuspenseQuery } from '~/services'
import { useAddons } from '../hooks/useAddons'
import { usePlanProducts } from '../hooks/usePlanProducts'

type Props = {
  workspaceId: string
  className?: string
}

export const V2BillingUpgradeCallout = ({ workspaceId, className }: Props) => {
  const {
    data: { billingVersion },
  } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId })

  const { currentPlan } = usePlanProducts(workspaceId)
  const { addons } = useAddons(workspaceId)

  const hasPaidPlan = currentPlan.legacyName !== 'community'
  const hasAddons = addons.some((addon) => addon.currentQuantity > 0)

  if (billingVersion !== 'v2' || hasPaidPlan || hasAddons) {
    return null
  }

  return (
    <ColoredAlert color="blue" className={className}>
      <InfoIcon className="size-5" />
      <AlertTitle className="mb-0 text-sm">
        This Workspace will move to the updated pricing model on December 22.{' '}
        <a
          href="https://botpress.com/blog/pricing-updates-nov-2025"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          Learn more
        </a>
      </AlertTitle>
    </ColoredAlert>
  )
}
